import request from '@/service'
import type { Result } from '@/service/http/types'

// --------------------------------------------------------------------------------
// 接口类型定义
// --------------------------------------------------------------------------------

/**
 * 用户登录参数接口
 */
export interface UserLoginParams {
  username: string
  password: string
}

/**
 * 用户注册参数接口
 */
export interface UserRegisterParams {
  username: string
  password: string
  rePassword: string
  email: string
}

/**
 * 用户信息接口
 */
export interface UserInfo {
  id: string
  username: string // 昵称
  nickname: string // 账号
  email: string
  token?: string
  isBindVx?: boolean
  roleIds?: number[]
}

/**
 * 找回密码想相关传参
 */
export interface FindPasswordParams {
  email: string
  captcha?: string
  password?: string
}

/**
 * 修改密码参数接口
 */
export interface ChangePasswordParams {
  password: string
  newPassword: string
  rePassword: string
}

/**
 * 绑定邮箱账号参数接口
 */
export interface BindEmailParams {
  userName: string
  password: string
}

// --------------------------------------------------------------------------------
// 接口请求方法
// --------------------------------------------------------------------------------

/**
 * 用户登录接口
 * @param params 登录参数
 * @returns Promise<Result<UserInfo>>
 */
export const userLogin = (params: UserLoginParams): Promise<Result<UserInfo>> => {
  return request.request<Result<UserInfo>>({
    url: '/apiAuth/authLogin/login',
    method: 'POST',
    data: params,
  })
}

/**
 * 退出
 */
export const userLogout = (): Promise<Result<void>> => {
  return request.request<Result<void>>({
    url: '/apiAuth/authLogin/logout',
    method: 'GET',
  })
}

/**
 * 注册接口
 * @param params 注册参数
 * @returns Promise<Result<UserInfo>>
 */
export const userRegister = (params: UserRegisterParams): Promise<Result<void>> => {
  return request.request<Result<void>>({
    url: '/apiAuth/authLogin/register',
    method: 'POST',
    data: params,
  })
}

/**
 * 找回密码收发验证码
 * @param params FindPasswordCodeParams
 * @returns Promise<Result<string>>
 */
export const userGetValidateCode = (params: FindPasswordParams): Promise<Result<void>> => {
  return request.request<Result<void>>({
    url: '/apiAuth/authLogin/findPassword',
    method: 'POST',
    data: params,
  })
}

/**
 * 找回密码验证验证码信息是否正确
 * @returns Promise<Result<ValidateCodeParams>>
 */
export const userMatchValidateCode = (
  params: FindPasswordParams,
): Promise<Result<FindPasswordParams>> => {
  return request.request<Result<FindPasswordParams>>({
    url: '/apiAuth/authLogin/validatePassword',
    method: 'POST',
    data: params,
  })
}

/**
 * 找回密码重置密码
 * @returns Promise<Result<UserInfo>>
 */
export const userResetPassword = (params: FindPasswordParams): Promise<Result<void>> => {
  return request.request<Result<void>>({
    url: '/apiAuth/authLogin/newPassword',
    method: 'POST',
    data: params,
  })
}
/**
 * 修改密码
 * @returns Promise<Result<UserInfo>>
 */
export const userChangePassword = (params: ChangePasswordParams): Promise<Result<void>> => {
  return request.request<Result<void>>({
    url: '/apiAuth/authLogin/changePassword',
    method: 'POST',
    data: params,
  })
}

/**
 * 绑定邮箱账号
 * @param params BindEmailParams
 * @returns Promise<Result<UserInfo>>
 */
export const userBind = (params: BindEmailParams): Promise<Result<UserInfo>> => {
  return request.request<Result<UserInfo>>({
    url: '/apiAuth/v1/vxAuth/bind',
    method: 'POST',
    data: params,
  })
}

export const userUnbind = (): Promise<Result<void>> => {
  return request.request<Result<void>>({
    url: '/apiAuth/v1/vxAuth/unbind',
    method: 'GET',
  })
}
